import { SET_DATE_REPORTS_REQUESTED, SET_FILTER_ROUTE_REPORT_PRODUCTS, SET_FILTER_SELECTED_USER_HISTORY_CLIENT, SET_MESSAGE_REPORTS_REQUESTED } from 'orden_express/reports/reportsActions.js';
import { REQUEST_RESET_STATE_REPORTS, RESPONSE_GET_REPORT_DASHBOARD, RESPONSE_GET_REPORT_HISTORY_CLIENT, RESPONSE_GET_REPORT_PRODUCTS_REQUESTED } from 'orden_express/reports/reportsEpic.js';


const initialState = {
   responseGetReportProductsRequested: {},
   messageReportsRequested: 0,
   dateReportsRequested: new Date(),
   responseGetReportDashboard: {},
   filterRouteReportProducts: { value: '@', label: 'Todos' },
   responseGetReportHistoryClient: {},
   filterSelecteduserHistoryClient: { label: '', value: '%' },
};

const reportsReducer = (state = initialState, action) => {
   switch (action.type) {

      case REQUEST_RESET_STATE_REPORTS:
         return initialState;

      case SET_FILTER_ROUTE_REPORT_PRODUCTS:
         return {
            ...state,
            filterRouteReportProducts: action.filterRouteReportProducts,
         }

      case SET_FILTER_SELECTED_USER_HISTORY_CLIENT:
         return {
            ...state,
            filterSelecteduserHistoryClient: action.filterSelecteduserHistoryClient,
         }

      case RESPONSE_GET_REPORT_HISTORY_CLIENT:
         return {
            ...state,
            responseGetReportHistoryClient: action.responseGetReportHistoryClient,
            messageReportsRequested: action.responseGetReportHistoryClient.errorState === true ? 3 : 2,
         };

      case RESPONSE_GET_REPORT_DASHBOARD:
         return {
            ...state,
            responseGetReportDashboard: action.responseGetReportDashboard,
            messageReportsRequested: action.responseGetReportDashboard.errorState === true ? 3 : 2,
         };

      case SET_DATE_REPORTS_REQUESTED:
         return {
            ...state,
            dateReportsRequested: action.dateReportsRequested
         };

      case SET_MESSAGE_REPORTS_REQUESTED:
         return {
            ...state,
            messageReportsRequested: action.messageReportsRequested
         };

      case RESPONSE_GET_REPORT_PRODUCTS_REQUESTED:
         return {
            ...state,
            responseGetReportProductsRequested: action.responseGetReportProductsRequested,
            messageReportsRequested: action.responseGetReportProductsRequested.errorState === true ? 3 : 2,
         };

      default:
         return state;
   }
};

export default reportsReducer;